export default "__VITE_ASSET__B7E028O___"